// extracted by mini-css-extract-plugin
export default {"total":"ValidatorActions_total__P7R9V"};